import {
  IconKey,
  IconLogout,
  IconMenu3,
  IconMenu4,
  IconUser,
} from "@tabler/icons-react";
import appAssets from "../../constants/assets";
import { Avatar, Popover } from "antd";
import useUIStore from "../../store/ui";
import { useAuth } from "../../store";
import moment from "moment";
import appColors from "../../theme/common/colors";
import ChangePasswordModal from "../Forms/changePassword";
import { useState } from "react";
import AppNotifications from "../Notifications";

const AppHeader = () => {
  const { toggleSidebar, isSidebarOpen } = useUIStore((state) => state);
  const logOut = useAuth((state) => state.logOut);
  const userInfo = useAuth((state) => state.user.info);
  const role = useAuth((state) => state.user.role);
  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);

  return (
    <header className="bg-white border border-borderGray fixed top-0 left-0 w-full z-10">
      <div className=" px-4 py-2 flex justify-between items-center">
        <div className="flex gap-2 flex-row items-center ml-1">
          <div
            onClick={toggleSidebar}
            className="hover:bg-slate-200 p-2 rounded-xl duration-200 cursor-pointer"
          >
            {isSidebarOpen ? (
              <IconMenu3 size={25} strokeWidth={1.5} />
            ) : (
              <IconMenu4 size={25} strokeWidth={1.5} />
            )}
          </div>
          <img
            src={appAssets.common.logo}
            alt="My Attendance Flow"
            className="h-8"
          />
          <div className="text-xl font-normal text-slate-600">EdConnex</div>
        </div>

        <nav className="flex mr-3">
          <AppNotifications />

          {/* <Button type="text">
            <IconLanguage strokeWidth={1.3} />
          </Button> */}

          <Popover
            content={
              <div>
                <div className="flex gap-2 flex-row items-start rounded-[32px] px-1 mb-2">
                  <Avatar
                    icon={<IconUser />}
                    className="mt-1"
                    style={{
                      backgroundColor: "#eaf3ff",
                      color: appColors.primary,
                    }}
                  />
                  <div>
                    <div className="text-[15px] font-medium">{role}</div>
                    {/* <p className="text-[13px] text-slate-500">{role}</p> */}
                    <p className="text-[13px] text-slate-500">
                      {userInfo?.email}
                    </p>
                  </div>
                </div>
                <div className="text-[13px] mt-3  font-medium text-slate-600 mb-4 text-center py-1 bg-[#f4f4f4] px-2 rounded-[8px]">
                  Last login:{" "}
                  <span className="font-light text-slate-600">
                    {moment(userInfo?.last_login).calendar()}
                  </span>
                </div>
                <div
                  onClick={() => {
                    setChangePasswordModalVisible(true);
                    document.body.click(); // Close the popover menu
                  }}
                  className="px-2 flex flex-row py-2 hover:bg-[#f1f1f1] cursor-pointer rounded-[10px] duration-300"
                >
                  <IconKey strokeWidth={1.3} />
                  <span className="ml-2">Change Password</span>
                </div>
                <div
                  onClick={logOut}
                  className="px-2 flex flex-row py-2 hover:bg-[#f1f1f1] cursor-pointer rounded-[10px] duration-300"
                >
                  <IconLogout strokeWidth={1.3} color="red" />
                  <span className="ml-2">Log Out</span>
                </div>
              </div>
            }
            trigger="click"
          >
            <div className="flex gap-2 flex-row items-center rounded-[32px] border pl-3 pr-5  border-slate-300 cursor-pointer">
              <IconUser strokeWidth={1.3} size={22} />

              <div>
                {userInfo ? (
                  <p className="text-[18px] font-light">
                    {userInfo.first_name.charAt(0).toUpperCase() +
                      userInfo.first_name.slice(1) +
                      " " +
                      userInfo.last_name.charAt(0).toUpperCase() +
                      userInfo.last_name.slice(1)}
                  </p>
                ) : (
                  <p className="text-[18px] font-light text-red-500">
                    Unknown User
                  </p>
                )}
              </div>
            </div>
          </Popover>
        </nav>
        <ChangePasswordModal
          visible={changePasswordModalVisible}
          setVisiblity={setChangePasswordModalVisible}
        />
      </div>
    </header>
  );
};

export default AppHeader;
